import React from "react";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import API from "@beardeddevops/react.api";
import {Parts} from "../index";
import {confirmAlert} from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import {Button, ButtonGroup} from "reactstrap";
import Checkbox from "@material-ui/core/Checkbox";

export default class BusinessCard extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Business_Cards._name);

		this.state = {
			...this.state,
			current_address: this.props.current_address,
			requested_address: null,
			checkbox: null
		};
	}

	getRequestedAddressString = () => {
		const {street_1, city, state, zip} = this.state;
		return `${street_1 || ""}, ${city || ""} ${state || ""}, ${zip || ""}`.trim();
	};

	handleSubmit = async (event) => {
		const {street_1, city, state, zip, current_address, checkbox} = this.state;
		this.state.approved = null;

		// Basic validation
		if (!street_1 || !city || !state || !zip) {
			API.Toast.error("Address is required.", {
				position: API.Toast.POSITION.TOP_CENTER,
				autoClose: 2000
			});
			return;
		}

		if (!checkbox) {
			API.Toast.error("You must acknowledge the checkbox.", {
				position: API.Toast.POSITION.TOP_CENTER,
				autoClose: 2000
			});
			return;
		}

		const requestedAddress = this.getRequestedAddressString();

		// Compare addresses
		if (requestedAddress !== current_address) {
			confirmAlert({
				title: "Confirm Shipping Address",
				message: `The requested address is different than the current address on file.\n\nSend cards to:\n${requestedAddress}?`,
				buttons: [
					{
						label: "Yes",
						onClick: async () => {
							this.state.requested_address = requestedAddress;
							super.handleSubmit(event);
						},
					},
					{
						label: "No",
						onClick: () => {
						},
					},
				],
			});
		} else {
			this.state.requested_address = requestedAddress;
			await super.handleSubmit(event);
		}
	};

	handleSent = async () => {
		let model = API.BuildClass(Types.Business_Cards._name, "POST")
		this.state.sent = true;
		await model.submit(this, "POST")
		window.location.reload();
	};

	handleApprove = async () => {
		await this.updateStatus(1);
	};

	handleDeny = async () => {
		await this.updateStatus(0);
	};

	updateStatus = async (status) => {
		let model = API.BuildClass(Types.Business_Cards._name, "POST")
		this.state.approved = status;
		await model.submit(this, "POST")
		window.location.reload();
	}


	renderBottomActions = () => {
		const {pkey, loading} = this.state;

		if (!this.props.canSeeStatus) {
			return null;
		}

		// Existing card → Approve / Deny
		if (pkey) {
			return (
				<div className="d-flex justify-content-end p-3">
					{!this.state.sent && <button className="btn btn-info mr-2" onClick={this.handleSent}>
						Cards Sent
					</button>}
					{this.state.approved !== true && <button className="btn btn-success mr-2" onClick={this.handleApprove}>
						Approve
					</button>}
					<button className="btn btn-danger" onClick={this.handleDeny}>
						Deny
					</button>
				</div>
			);
		}

		// // New card → Submit
		// return (
		// 	<div className="d-flex justify-content-end p-3">
		// 		<button
		// 			className="btn btn-primary"
		// 			onClick={this.handleSubmit}
		// 			disabled={loading}
		// 		>
		// 			Submit
		// 		</button>
		// 	</div>
		// );
	};

	render() {
		let {properties} = this.model;
		let {loading, pkey} = this.state;

		return (
			<Card>
				<CardContent>
					<div className={"form-group"}>
						<h4 className="section-title">Address</h4>
						<div className={'row'}>

							{/* ✅ EXISTING + ADMIN → side-by-side */}
							{pkey && this.props.isAdmin && (
								<>
									<div className={"col-md-5"}>
										<div className="form-group">
											<Framework.Elements.TextField
												property={properties.requested_address}
												value={this.state.requested_address}
												error={this.state.requested_address_error}
												label={'Shipping Address'}
												disabled={true}
											/>
										</div>
									</div>

									<div className={"col-md-5"}>
										<div className="form-group">
											<Framework.Elements.TextField
												property={properties.current_address}
												value={this.state.current_address || "No address on file"}
												error={this.state.current_address_error}
												label={'Current Address'}
												disabled={true}
											/>
										</div>
									</div>
								</>
							)}

							{pkey && !this.props.isAdmin && (
								<div className={"col-10"}>
									<div className="form-group">
										<Framework.Elements.TextField
											property={properties.requested_address}
											value={this.state.requested_address}
											error={this.state.requested_address_error}
											label={'Requested Address'}
											disabled={true}
										/>
									</div>
								</div>
							)}

							{pkey &&
								<>
									{this.props.canSeeStatus && <div className={'col-1'}>
										<div className={'form-group'}>
											<Framework.Elements.Checkbox
												property={properties.approved}
												value={this.state.approved}
												error={this.state.approved_error}
												color="primary"
												label={'Approved'}
												disabled={true}
											/>
										</div>
									</div>}
									<div className={'col-1'}>
										<div className={'form-group'}>
											<Framework.Elements.Checkbox
												property={properties.sent}
												value={this.state.sent}
												error={this.state.sent_error}
												color="primary"
												label={'Sent'}
												disabled={true}
											/>
										</div>
									</div>
								</>
							}

							{!pkey && (
								<div className={'col-12'}>
									<Parts.Address
										object={{...this.state}}
										properties={properties}
										parent={this}
									/>
								</div>
							)}


							<div className={'col-12'}>
								<div className="form-group">
									<Framework.Elements.TextField
										property={properties.notes}
										value={this.state.notes}
										error={this.state.notes_error}
										update={this.handleTextFieldPropertyUpdate}
										label={'Note any abnormalities in your address, or any other relevant notes'}
										multiline={4}
										disabled={pkey}
									/>
								</div>
							</div>

							{!pkey && <div className={'col-12'}>
								<div className="form-group">
									<Checkbox
										checked={this.state.checkbox}
										onChange={() => this.setState({checkbox: !!!this.state.checkbox})}
										color={'primary'}
										style={{height: 19, padding: 0, paddingRight: 10}}
									/>
									<span>I would like to request optional Company-branded marketing materials. I acknowledge these materials are offered for lead routing and as a convenience to help customers identify me during appointments coordinated through the ServiceBookr platform. Use of these materials is voluntary and does not modify my status as an independent business entity.</span>
								</div>
							</div>}

						</div>
					</div>
				</CardContent>

				{this.renderBottomActions()}

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</Card>
		);
	};
}